// src/pages/purchase-requisition/components/MaterialAutocomplete.jsx
import React, { useState, useEffect } from 'react';
import {
    TextField,
    Autocomplete,
    CircularProgress
} from "@mui/material";
import { database } from "../../../firebase";
import { ref, onValue } from "firebase/database";

function MaterialAutocomplete({ value, onChange, error, helperText, freeSolo = true, ...props }) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [isManualInput, setIsManualInput] = useState(false);

    const [isManualInputActive, setIsManualInputActive] = useState(false);

    // Ambil data kode material dari Firebase
    useEffect(() => {
        setLoading(true);
        const materialRef = ref(database, 'db_warehouse/db_ppic/db_config/tb_kode_material');
        
        const unsubscribe = onValue(materialRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const materialList = Object.keys(data).map(key => ({
                    id: key,
                    kode_material: data[key].kode_material || '',
                    deskripsi_material: data[key].deskripsi_material || ''
                }));
                setOptions(materialList);
            } else {
                setOptions([]);
            }
            setLoading(false);
        }, (error) => {
            console.error("Error fetching material data:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

const handleMaterialSelect = (event, newValue, reason) => {
    if (reason === 'clear') {
        // Nilai dihapus (clear button ditekan)
        onChange({
            target: {
                name: props.name,
                value: '',
                isManualInput: false
            }
        });
        
        // Reset deskripsi
        if (props.onDescriptionChange) {
            props.onDescriptionChange('');
        }
        setIsManualInput(false);
        setIsManualInputActive(false);
        setInputValue(''); // Reset input value
    } else if (typeof newValue === 'string') {
        // Input manual - kirim sebagai object event yang konsisten
        setIsManualInput(true);
        setIsManualInputActive(true);
        onChange({
            target: {
                name: props.name,
                value: newValue,
                isManualInput: true
            }
        });
        
        // Reset deskripsi jika input manual
        if (props.onDescriptionChange) {
            props.onDescriptionChange('');
        }
    } else if (newValue) {
        // Pilihan dari dropdown - kirim object event
        setIsManualInput(false);
        setIsManualInputActive(false);
        onChange({
            target: {
                name: props.name,
                value: newValue.kode_material,
                isManualInput: false
            }
        });
        
        // Juga trigger onChange untuk field terkait
        if (props.onDescriptionChange) {
            props.onDescriptionChange(newValue.deskripsi_material);
        }
    }
};

     const handleInputChange = (event, newInputValue, reason) => {
        setInputValue(newInputValue);
        // Jika user mulai mengetik manual, set flag
        if (newInputValue && !options.some(opt => opt.kode_material === newInputValue)) {
            setIsManualInput(true);
            setIsManualInputActive(true); // Set state manual input aktif
        } else if (!newInputValue) {
            setIsManualInputActive(false); // Reset jika kosong
        }
    };

    const shouldShowError = error && !isManualInputActive && !value;

    return (
        <Autocomplete
            freeSolo={freeSolo}
            options={options}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.kode_material;
            }}
            value={value ? options.find(option => option.kode_material === value) || value : null}
            onChange={handleMaterialSelect}
            onInputChange={handleInputChange}
            inputValue={inputValue}
            loading={loading}
            sx={{ minWidth: 200 }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...props}
                    error={shouldShowError} // Gunakan calculated error state
                    helperText={shouldShowError ? helperText : ''} // Hanya tampilkan helper text jika error
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            </React.Fragment>
                        ),
                    }}
                    size="small"
                />
            )}
            isOptionEqualToValue={(option, value) => {
                if (typeof option === 'string' || typeof value === 'string') {
                    return option === value;
                }
                return option.kode_material === value.kode_material;
            }}
            clearOnBlur={false}
            // Hilangkan tombol clear
            clearOnEscape={false}
            disableClearable={true}
        />
    );
}

export default MaterialAutocomplete;